import React, { useState } from "react"
import { openAiTargetingAccessDialog } from "./AiTargetingAccessDialog"

export default function AiTargetingBanner({ isAiTargetingMode, teamHasAccess, onToggleAiMode, isSwitchingMode }) {
  const [isRequestingAccess, setIsRequestingAccess] = useState(false)

  const handleRequestAccess = async () => {
    if (isRequestingAccess) return

    setIsRequestingAccess(true)

    try {
      await openAiTargetingAccessDialog()
    } finally {
      setIsRequestingAccess(false)
    }
  }

  if (teamHasAccess) {
    return (
      <div className="row mb-3">
        <div className="col-12">
          <div className={`ai-banner ${isAiTargetingMode ? "ai-banner--active" : "ai-banner--available"}`}>
            <div className="ai-banner__body">
              <div className="ai-banner__icon">
                <i className="fas fa-crosshairs"></i>
              </div>
              <div>
                <div className="ai-banner__title">
                  {isAiTargetingMode ? "Diffusion intelligente (IA) active" : "Diffusion intelligente (IA) disponible"}
                </div>
                <div className="ai-banner__subtitle">
                  {isAiTargetingMode ? (
                    <>
                      Ce totem est équipé d'une caméra connectée à un module d'IA.
                      <br />
                      Vos publicités s'adaptent automatiquement au profil de l'audience.
                    </>
                  ) : (
                    <>
                      Ce totem est équipé d'une caméra connectée à un module d'IA.
                      <br />
                      Activez la diffusion intelligente (IA) pour que vos publicités s'adaptent automatiquement au profil de l'audience.
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="ai-banner__actions">
              <button
                type="button"
                className={`ai-banner__btn ${isAiTargetingMode ? "ai-banner__btn--deactivate" : "ai-banner__btn--activate"}`}
                onClick={onToggleAiMode}
                disabled={isSwitchingMode}
              >
                {isAiTargetingMode ? (
                  <>
                    <i className="fas fa-arrow-left mr-1"></i> Revenir au mode standard
                  </>
                ) : (
                  <>
                    <i className="fas fa-crosshairs mr-1"></i> Activer la diffusion intelligente
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="ai-banner ai-banner--locked">
          <div className="ai-banner__body">
            <div className="ai-banner__icon ai-banner__icon--locked">
              <i className="fas fa-crosshairs"></i>
            </div>
            <div>
              <div className="ai-banner__title">Diffusion intelligente (IA) disponible</div>
              <div className="ai-banner__subtitle">
                Ce totem est équipé d'une caméra connectée à un module d'IA.
                <br />
                Demandez l'accès pour que vos publicités s'adaptent automatiquement au profil de l'audience.
              </div>
            </div>
          </div>
          <div className="ai-banner__actions">
            <button
              type="button"
              className="ai-banner__btn ai-banner__btn--request"
              onClick={handleRequestAccess}
              disabled={isRequestingAccess}
            >
              <i className="fas fa-envelope mr-1"></i> Demander l'accès
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
